import { faBan } from "@fortawesome/free-solid-svg-icons/faBan";
import { faPlus as plus } from "@fortawesome/free-solid-svg-icons/faPlus";
import { faTimes } from "@fortawesome/free-solid-svg-icons/faTimes";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Dialog, DialogActions, DialogContent, DialogProps } from "@mui/material";
import React, { useState, useRef } from "react";
import { useFormik } from "formik";
import { payloadEnviarEmail, RespostaModalEnviarEmail } from "app/types/modalImprimir/RespostaModalImprimir";
import {EditorDeTexto} from "../../../../editorTexto/EditorDeTexto";
import { PaperArrastavel } from "../../../../dialog-arrastavel/PaperArrastavel";

const estiloModalEnviarEmail =
    require("./modalEnviarEmail.module.scss").default;


export type ModalEnviarEmailProps = {
    processando?: boolean
    RespostaModalEnviarEmail?: RespostaModalEnviarEmail;
    PermitidoAnexarEmail: boolean;
    Anexos: any;
    PermitidoCopia: boolean
    PermitidoCopiaOculta: boolean
    PermitidoAlterarAssunto: boolean
    PermitidoAlterarMensagem: boolean
    urlTemplate?: string;
    onClose: () => void;
    onEnviar: (dados: payloadEnviarEmail) => void;
    onAnexar: (event) => void;
    onRemoverAnexo: (AnexoRemovido: any, pos: number) => void;
};

export const ModalEnviarEmail = (props: ModalEnviarEmailProps) => {
    const [scroll, setScroll] = useState<DialogProps["scroll"]>("paper");
    const hiddenFileInput = useRef(null);

    const formik = useFormik({
        initialValues: {

            ...props.RespostaModalEnviarEmail,
            destinatarioInput: props.RespostaModalEnviarEmail && props.RespostaModalEnviarEmail?.Destinatarios && props.RespostaModalEnviarEmail?.Destinatarios.length >= 1 ? props.RespostaModalEnviarEmail?.Destinatarios[0] : "",

        },
        onSubmit: (values, { }) => { },
        enableReinitialize: true,

    });
    const handleClickAnexar = () => {
        hiddenFileInput.current.click();
    }

    const tabelaAnexos = <table id="ModalEnviarEmail_TabelaAnexos" className={estiloModalEnviarEmail.informacoesAnexos}>
        <tbody>


        {props.RespostaModalEnviarEmail?.Anexos?.map((Anexo, index) =>
            <tr key={`ModalEnviarEmail_AnexoExistente_${index}`}>
                <td>
                    <a id={`ModalEnviarEmail_AnexoExistenteLink_${index}`} title={Anexo.NomeArquivo} href={props?.urlTemplate} download={Anexo.NomeArquivo}>
                        {Anexo.NomeArquivo}
                    </a>
                </td>
            </tr>
        )}
        {props?.Anexos?.map((Anexo, pos) =>
            <tr key={`ModalEnviarEmail_AnexoNovo_${pos}`}>
                <td>
                    <p id={`ModalEnviarEmail_AnexoNovoNome_${pos}`} title={Anexo?.name} >
                        {Anexo?.name}
                    </p>
                </td>
                <td>
                    <p id={`ModalEnviarEmail_AnexoNovoTamanho_${pos}`} className={estiloModalEnviarEmail.tamanhoAnexo}>
                        {" " + (Anexo?.size / 1024).toFixed(2) + " KB"}
                    </p>
                </td>
                <td>
                    <button
                        id={`ModalEnviarEmail_BotaoRemoverAnexo_${pos}`}
                        className={estiloModalEnviarEmail.botaoRemoverAnexo}
                        disabled={props.processando}
                        onClick={() => props.onRemoverAnexo(Anexo, pos)}
                    >
                        <FontAwesomeIcon
                            icon={faBan}
                        />
                        Remover
                    </button>
                </td>
            </tr>
        )}

        </tbody>
    </table>


    const conteudoModal = <div id="ModalEnviarEmail_ConteudoModal" className={estiloModalEnviarEmail.conteudoModal}>
        <div className={estiloModalEnviarEmail.InformacoesEnviarEmail}>
            <label id="ModalEnviarEmail_LabelDestinatario" className={estiloModalEnviarEmail.primeiraColuna}>Destinatário</label>

            <select id="ModalEnviarEmail_SelectDestinatarios" name="Destinatarios"
                    defaultValue={props.RespostaModalEnviarEmail && props.RespostaModalEnviarEmail?.Destinatarios && props.RespostaModalEnviarEmail?.Destinatarios.length >= 1 ? props.RespostaModalEnviarEmail?.Destinatarios[0] : ""}
                    onChange={(e) => formik.setFieldValue("destinatarioInput", e.target.value)}
            >
                {
                    props.RespostaModalEnviarEmail?.Destinatarios?.length >= 1 ?
                        props.RespostaModalEnviarEmail?.Destinatarios?.map(
                            (destinatario) =>
                                <option key={`ModalEnviarEmail_OptionDestinatario_${destinatario}`} value={destinatario}>{destinatario}</option>
                        )
                        : null
                }

            </select>

            <label id="ModalEnviarEmail_LabelCopia" className={estiloModalEnviarEmail.primeiraColuna}>Cópia</label>
            <input id="ModalEnviarEmail_InputCopia" name="Copia" 
                disabled={!props.PermitidoCopia || props.processando} 
                value={(formik.values.Copia) ?? ""} 
                onChange={(e) => formik.setFieldValue('Copia', e.target.value)}
            />
            <label id="ModalEnviarEmail_LabelCopiaOculta" className={estiloModalEnviarEmail.primeiraColuna}>Cópia oculta</label>
            <input id="ModalEnviarEmail_InputCopiaOculta" name="CopiaOculta" 
                disabled={!props.PermitidoCopiaOculta || props.processando} 
                value={(formik.values.CopiaOculta) ?? ""} onChange={(e) => formik.setFieldValue('CopiaOculta', e.target.value)}></input>
            <label id="ModalEnviarEmail_LabelAssunto" className={estiloModalEnviarEmail.primeiraColuna}>Assunto</label>
            <input id="ModalEnviarEmail_InputAssunto" name="Assunto" 
                disabled={!props.PermitidoAlterarAssunto || props.processando} 
                defaultValue={props.RespostaModalEnviarEmail?.Assunto} 
                onChange={formik.handleChange}></input>
        </div>
        <br />
        <EditorDeTexto
            permitidoAlterarMensagem={props.PermitidoAlterarMensagem}
            onChange={(texto) => formik.setFieldValue('Mensagem', texto)}
            mensagem={props?.RespostaModalEnviarEmail?.Mensagem}
        />
    </div>

    const dialogActions = <DialogActions
        id="ModalEnviarEmail_DialogActions"
        style={{
            justifyContent: "right",
        }}
        disableSpacing={true}
        className={estiloModalEnviarEmail.dialogActions}
    >
        <div className={estiloModalEnviarEmail.modalActions}>
            <button
                id="ModalEnviarEmail_BotaoEnviar"
                disabled={props.processando}
                className={estiloModalEnviarEmail.buttonModalEnviarEmail}
                onClick={(e) => {
                    props.onEnviar(formik.values);
                }}
                style={{
                    margin: "0 3px 0 0",
                    padding: "7px 1em",
                }}
            >
                Enviar
            </button>
            <button
                id="ModalEnviarEmail_BotaoFechar"
                disabled={props.processando}
                className={estiloModalEnviarEmail.buttonModalEnviarEmail}
                onClick={props.onClose}
                style={{
                    margin: "0 3px 0 0",
                    padding: "7px 1em",
                }}
            >
                Fechar
            </button>
        </div>

    </DialogActions>


    return (
        <>
            <Dialog
                id="ModalEnviarEmail_Dialog"
                open={true}
                onClose={props.onClose}
                scroll={scroll}
                className={estiloModalEnviarEmail.dialogModalSenha}
                PaperComponent={PaperArrastavel}
            >

                <div id="ModalEnviarEmail_Cabecalho" className={estiloModalEnviarEmail.titulo} data-arrastar-dialog>
                    <h4 style={{ fontWeight: 700 }}>
                        Enviar por e-mail
                    </h4>
                    <div>
                        <a id="ModalEnviarEmail_BotaoFecharCabecalho" onClick={props.onClose} >
                            <FontAwesomeIcon
                                id="ModalEnviarEmail_IconeFechar"
                                icon={faTimes}
                                cursor={"pointer"}
                                className={estiloModalEnviarEmail.exit}
                                opacity={0.2}
                            />
                        </a>
                    </div>
                </div>
                <DialogContent
                    id="ModalEnviarEmail_DialogContent"
                    dividers={scroll === "paper"}
                    style={{ padding: "15px" }}

                >
                    {conteudoModal}
                    {props?.PermitidoAnexarEmail &&
                        < button
                            id="ModalEnviarEmail_BotaoAnexar"
                            className={`no-global-button ${estiloModalEnviarEmail.botaoAnexar}`}
                            onClick={handleClickAnexar}
                        >
                            <FontAwesomeIcon
                                id="ModalEnviarEmail_IconeAnexar"
                                icon={plus}
                                size="lg"
                            />

                            Anexar
                        </button>
                    }

                    <input
                        id="ModalEnviarEmail_InputArquivo"
                        style={{display: 'none'}}
                        type="file"
                        onChange={props.onAnexar}
                        ref={hiddenFileInput}
                    />

                    {tabelaAnexos}
                    <br />

                    {dialogActions}
                </DialogContent>
            </Dialog>
        </>
    )
}